// extracted by mini-css-extract-plugin
export default {"mobileMaxWidth":"767px","mobilePanelHeight":"50%","mobileNavbarHeight":"55px","errorMessage":"FeatureView_errorMessage__Ah9J9"};